var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-input-calendar',{attrs:{"input-label":_vm.$t('expiration_date'),"min-date":_vm.defaultDate,"default-value":_vm.defaultDate,"id":"expirationDate","name":"expiration-date"},on:{"update-value":_vm.updateExtendedDate}})}
var staticRenderFns = []

export { render, staticRenderFns }